import Icon from "components/atoms/icon"
import { Text } from "components/atoms/typography"
import styled from "styled-components"
import { COLOR } from "styles/style-constants"

const ItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex-grow: 1;
  flex-basis: 0;
  z-index: 0;
  border-top: 5px solid
    ${(props) => (props.active ? COLOR.deepBlueHover : COLOR.lineGray)};
  padding-top: 10px;
  color: ${(props) => (props.active ? COLOR.deepBlueHover : COLOR.lineGray)};
  ${(props) => props.leftStep && "margin-right:1px;"}
  ${(props) => props.rightStep && "margin-left:1px;"}
  ${(props) =>
    props.centerStep &&
    `
    margin: 0 1px 0 1px;`}
    &:hover {
    cursor: pointer;
  }
`

const IconWrapper = styled.span`
  position: absolute;
  top: -5px;
  margin-bottom: 10px;
  width: 13px;
  height: 13px;
  background: white;
  border-radius: 30px;
  border-top: 2px solid;
  border-left: 2.5px solid;
  border-right: 2.5px solid;
  border-bottom: 2.5px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  ::before {
    z-index: -1;
    content: "";
    width: 10px;
    height: 9px;
    position: absolute;
    background: transparent;
    border-radius: 30px;
    left: -7.5px;
    top: -2px;
    box-shadow: inset -5px 5px 0 0px ${(props) => (props.active ? COLOR.deepBlueHover : COLOR.lineGray)};
  }
  ::after {
    z-index: -1;
    content: "";
    width: 10px;
    height: 9px;
    position: absolute;
    background: transparent;
    border-radius: 30px;
    right: -7.5px;
    top: -2px;
    box-shadow: inset 5px 5px 0 0px
      ${(props) => (props.active ? COLOR.deepBlueHover : COLOR.lineGray)};
  }
`

export const ProgressItemV2Text = styled(Text)`
  ${(props) =>
    `color: ${props.active ? COLOR.deepBlueHover : COLOR.lightGray};`}
  ${(props) => props.hideDesktop && "display: none;"}
  @media (max-width: 520px) {
    ${(props) => props.hideDesktop && "display: block;"}
    ${(props) => props.hideMobile && "display: none;"}
  }
`

const ProgressItemV2 = ({
  id,
  ready,
  progressName,
  progressIndex,
  totalProgress,
  isCurrentStep,
  onClick = () => {},
}) => (
  <ItemWrapper
    id={id}
    active={isCurrentStep}
    // these 3 props below are using for styling gap between each step
    centerStep={progressIndex !== 1 && progressIndex !== totalProgress}
    leftStep={progressIndex === 1}
    rightStep={progressIndex === totalProgress}
    onClick={onClick}>
    {ready && (
      <IconWrapper active={isCurrentStep}>
        <Icon
          iconName="success"
          size="9"
          color={COLOR.deepBlueHover}
          zIndex={100}
          left="0.5px"
        />
      </IconWrapper>
    )}
    <ProgressItemV2Text m0 weight={600} active={isCurrentStep} hideMobile>
      {progressIndex}. {progressName}
    </ProgressItemV2Text>
  </ItemWrapper>
)

export default ProgressItemV2
